import { DateTime } from 'luxon'
import { CONFIG } from '../../../config'
import { getUsuarioInfo } from '../../localstorage/localstorage.service'
import { parseToMysqlFormat, parseToMysqlFormatWithTime } from '../../util/date.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/delivery`
const BASE_URL_MOBILE_EXPEDICAO = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/mobile-expedicao`

// Delivery
export function urlDelivery(delivery_id) {
  return `${BASE_URL}/${delivery_id}`
}

export function urlGetDeliveryByIdentifierLike(company_id, identifier) {
  return `${BASE_URL}/deliveries-by-identifier/${company_id}/${identifier}`
}

export function urlGetDeliveryByInvoiceNumberLike(company_id, invoice_number) {
  return `${BASE_URL}/deliveries-by-invoice-number/${company_id}/${invoice_number}`
}

export function urlGetDeliveryHome(user_id, tp_id, identifier) {
  return `${BASE_URL}/home/${user_id}/${tp_id}?identifier=${encodeURIComponent(identifier)}`
}

export function urlGetDeliveryHomeByProduct(user_id, tp_id, product) {
  return `${BASE_URL}/home-product/${user_id}/${tp_id}?product=${encodeURIComponent(product)}`
}

export function urlUpdateMultipleDelivery(tp_id) {
  return `${BASE_URL}/update-deliveires/${tp_id}`
}

export function urlUpdateDelivery() {
  return `${BASE_URL}/update-delivery`
}

export function urlUpdateDeliveryIdentifierAndInvoiceNumberByTp(tp_id) {
  return `${BASE_URL}/entregas-por-empresa/identifier-invoice-number/${tp_id}`
}

export function urlMissingProductByDeliveryId(delivery_id) {
  return `${BASE_URL}/missing_products/${delivery_id}`
}

// Ciclo de Entrega
export const urlPostDeliveryCycle = `${BASE_URL}/delivery-cycle`

export function urlDeliveryCycle(cycleId) {
  return `${BASE_URL}/delivery-cycle/${cycleId}`
}

export function urlGetDeliveriesCycleByIds(cyclesIds) {
  return `${BASE_URL}/delivery-cycle/multi/${cyclesIds}`
}

export function urlGetDeliveriesCycleRecebimentoByOpCenterId(opCenterId) {
  return `${BASE_URL}/deliveries-cycles/recebimento/${opCenterId}`
}

export function urlGetDeliveriesCycles(centralId, initialPeriod, finalPeriod) {
  return `${BASE_URL}/deliveries-cycles?operationcenter_id=${centralId}&initialPeriod=${initialPeriod}&finalPeriod=${finalPeriod}`
}

export function urlGetDeliveriesCyclesByNF(
  centralId,
  initialPeriod,
  finalPeriod,
  companyId,
  notaFiscal,
) {
  return `${BASE_URL}/deliveries-cycles-by-nf?operationcenter_id=${centralId}&initialPeriod=${initialPeriod}&finalPeriod=${finalPeriod}&company_id=${companyId}&notaFiscal=${notaFiscal}`
}

// Importação
export function urlPostImportacaoInfo(ciclo_id, file_type_id) {
  return `${BASE_URL}/importation/${ciclo_id}/${file_type_id}`
}

export function urlPostImportacaoMultiCicle(user_id, file_type_id) {
  return `${BASE_URL}/importation-multi/${file_type_id}/${user_id}`
}

export function urlPostImportacaoInfoPdf(ciclo_id, file_type_id) {
  return `${BASE_URL}/importation-pdf/${ciclo_id}/${file_type_id}?t=${localStorage.getItem('t')}`
}

export function urlPostImportacaoInfoEdi(ciclo_id, file_type_id) {
  return `${BASE_URL}/importation-edi/${ciclo_id}/${file_type_id}?t=${localStorage.getItem('t')}`
}

export function urlGetCicloInfo(ciclo_id) {
  return `${BASE_URL}/importation/ciclo-info/${ciclo_id}`
}

//Trechos (Steps)
export function urlPostTecho(ciclo_id, user_id) {
  return `${BASE_URL}/step/${ciclo_id}/${user_id}`
}

export function urlPostTechoPadroes(ciclo_id, user_id) {
  return `${BASE_URL}/assoc-delivery-default-step/${ciclo_id}/${user_id}`
}

export function urlGetTechosByCicloId(ciclo_id) {
  return `${BASE_URL}/step/${ciclo_id}`
}

export function urlDeleteTecho(step_id) {
  return `${BASE_URL}/step/${step_id}`
}

export function urlRemoverTrechos(ciclo_id) {
  return `${BASE_URL}/trechos/${ciclo_id}`
}

export function urlRemoverTrechosSelecionados(ciclo_id) {
  return `${BASE_URL}/trechos-selecionados/${ciclo_id}`
}

export const urlRemoverEntregas = `${BASE_URL}/remover-entregas`

// Carregamento de Veiculos
export function urlGetEntregasParaCarregamento(tp_id, pInicial, pFinal, user_id) {
  return `${BASE_URL}/loading-deliveries/${tp_id}/${user_id}?pInicial=${pInicial}&pFinal=${pFinal}`
}

export function urlGetPorcentagemConferidaEntregasParaCarregamento(tp_id, user_id) {
  return `${BASE_URL}/loading-deliveries/conference-percentages/${tp_id}/${user_id}`
}

export function urlPostCarregamentoVeiculo(tp_id, user_id) {
  return `${BASE_URL}/loading-deliveries/${tp_id}/${user_id}`
}

export function urlGetClientesComEntregasParaRoteirizacao(tp_id, pInicial, pFinal) {
  const { id: user_id } = getUsuarioInfo()

  return `${BASE_URL}/loading-deliveries/roteirizacao/${tp_id}/${user_id}?pInicial=${parseToMysqlFormat(pInicial)}&pFinal=${parseToMysqlFormat(pFinal)}`
}

export function urlGetClientesComEntregasCarregadasParaRoteirizacao(
  tp_id,
  expected_date,
  pInicial,
  pFinal,
) {
  const { id: user_id } = getUsuarioInfo()
  return `${BASE_URL}/loading-deliveries-loaded/roteirizacao/${tp_id}/${user_id}?expected_date=${parseToMysqlFormat(expected_date)}&pInicial=${parseToMysqlFormat(pInicial)}&pFinal=${parseToMysqlFormat(pFinal)}`
}

// Importação do Roteiro - Associação Placa e Entrega
export function urlPostImportacaoExcelRoteiroEntrega(tp_id, user_id) {
  return `${BASE_URL}/import-excel-delivery-script/${tp_id}/${user_id}`
}

export function urlPostCarregarPelaPlacaPrevista() {
  return `${BASE_URL}/carregar-pela-placa-prevista`
}

// Envio de Veiculo para Rota
export function urlGetFrotasParaEnvio(tp_id, user_id, pInicial, pFinal) {
  const query = [`user_id=${user_id}`]

  if (pInicial) query.push(`pInicial=${pInicial}`)
  if (pFinal) query.push(`pFinal=${pFinal}`)

  return `${BASE_URL}/fleets-to-deliver/${tp_id}?${query.join('&')}`
}

export function urlPutFleetObservation() {
  return `${BASE_URL}/fleet-observation`
}

export function urlGetEnviosParaFrota(tp_id, vehicle_badge, expected_date) {
  return `${BASE_URL}/fleet-deliveries/${tp_id}/${vehicle_badge}?expected_date=${expected_date}`
}

export function urlPostRoutesDistance(tp_id) {
  return `${BASE_URL}/routes-distance/${tp_id}`
}

export function urlSetDeliveryLoadOrder() {
  return `${BASE_URL}/delivery-load-order`
}

export function urlPutAlterarVeiculoMotorista(fleet_id) {
  return `${BASE_URL}/change-fleet-vehicle-driver?fleet_id=${fleet_id}`
}

export function urlPutCarregamentoEmPosicoesFleet(fleet_id) {
  return `${BASE_URL}/fleet-carregamento-em-posicoes?fleet_id=${fleet_id}`
}

export function urlPutDescarregarDeliveries(user_id) {
  return `${BASE_URL}/remove-delivery-from-fleet/${user_id}`
}

export function urlPutEnviarFrotaParaRota(user_id, sent_time) {
  return `${BASE_URL}/send-fleet-to-route/${user_id}/${sent_time}`
}

export function urlDepartureTimeFleetsInfo(tp_id) {
  return `${BASE_URL}/departure-time-vehicle-fleet/${tp_id}`
}

// Report: Mapa de Carregamento
export function urlReportMapaDeCarga(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-carregamento/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}
export function urlReportMapaDeEntrega(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-entrega/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}
export function urlReportMapaDeEntregaPicking(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-entrega-picking/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}
export function urlReportMapaDeEntregaIdentificador(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-entrega-identificador/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}
export function urlReportMapaDeCargaAnalitico(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-carregamento-analitico/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}
export function urlReportMapaDeCargaAnaliticoAgrupado(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-carregamento-analitico-agrupado/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}

export function urlReportMapaDeCargaAnaliticoProdutoEmpresa(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-carregamento-analitico-produto-empresa/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}

export function urlReportMapaDeCargaAnaliticoEmpresaCidade(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-carregamento-analitico-empresa-cidade/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}

export function urlReportMapaDeCargaAnaliticoGrupoEEmpresa(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-carregamento-analitico-grupo-empresa/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}

export function urlReportMapaCarregamentoEstoque(tp_id, fleetIds) {
  return `${BASE_URL}/report-mapa-de-carregamento-estoque/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}

export function urlReportTotalProdutosVeiculos(tp_id, fleetIds) {
  return `${BASE_URL}/report-total-produtos-veiculos/${tp_id}?fleet_ids=${fleetIds}&t=${localStorage.getItem('t')}`
}

export function urlGetTotalProdutosVeiculos(tp_id, fleetIds) {
  return `${BASE_URL}/report-total-produtos-veiculos-excel/${tp_id}?fleet_ids=${fleetIds}`
}

export function urlPostCancelarMapaEmitido(user_id) {
  return `${BASE_URL}/cancelar-mapa-emitido/${user_id}?user_id=${user_id}`
}

export function urlReportRelatorioEmbarcador(tp_id, company_id, pInicial, pFinal) {
  return `${BASE_URL}/report-relatorio-embarcador/${tp_id}/${company_id}?p_inicial=${parseToMysqlFormat(pInicial)}&p_final=${parseToMysqlFormat(pFinal)}&t=${localStorage.getItem('t')}`
}

export function urlReportRelatorioEmbarcadorExcel(tp_id, company_id, pInicial, pFinal) {
  return `${BASE_URL}/report-relatorio-embarcador-excel/${tp_id}/${company_id}?p_inicial=${parseToMysqlFormat(pInicial)}&p_final=${parseToMysqlFormat(pFinal)}&t=${localStorage.getItem('t')}`
}

// Entregas Por Empresa - Analítico
export function urlGetEntregasPorEmpresa(tp_id, company_id, p_inicial, p_final) {
  const inicial = parseToMysqlFormatWithTime(p_inicial)
  const final = parseToMysqlFormatWithTime(p_final)
  return `${BASE_URL}/deliveries-per-company/${tp_id}?company_id=${company_id}&p_inicial=${inicial}&p_final=${final}`
}

export function urlTimelineInfoToExport(tp_id, company_id, p_inicial, p_final) {
  const inicial = parseToMysqlFormatWithTime(p_inicial)
  const final = parseToMysqlFormatWithTime(p_final)
  return `${BASE_URL}/timeline-info-to-export/${tp_id}?company_id=${company_id}&p_inicial=${inicial}&p_final=${final}`
}

export function urlGetEntregaTimeline(delivery_id) {
  return `${BASE_URL}/delivery-timeline/${delivery_id}`
}

export function urlGetNotasFiscaisDevolucao(delivery_id) {
  return `${BASE_URL}/delivery-notas-fiscais-devolucao/${delivery_id}`
}

export function urlGetOcorrenciasEntregaPorEntrega(delivery_id) {
  return `${BASE_URL}/delivery-ocorrencias-entrega/${delivery_id}`
}

// Entregas Para Roteirização
export function urlGetEntregasParaRoteirizacao(
  statusIds,
  empresasIds,
  considerarEntregasEmSeparacao,
  selectedTp,
) {
  return `${BASE_URL}/entregas/roteirizacao?statusIds=${statusIds.join(',')}&empresasIds=${empresasIds.join(',')}&conconsiderarEntregasEmSeparacao=${considerarEntregasEmSeparacao ? 1 : 0}&selectedTp=${selectedTp}`
}

// Enderecamento das Entregas
export function urlGetEnderecamentoEntregas(selectedTp) {
  return `${BASE_URL}/entregas/enderecamento-entregas/${selectedTp}`
}

export function urlGetEnderecamentoEntregasAnalitico(selectedTp) {
  return `${BASE_URL}/entregas/enderecamento-entregas-analitico/${selectedTp}`
}

export function urlApagarEnderecamentoDaEntrega(delivery_id, endereco) {
  return `${BASE_URL_MOBILE_EXPEDICAO}/tracking/enderecamento/apagar-endereco-entrega?delivery_id=${delivery_id}&endereco=${endereco}`
}

export function urlSalvarEnderecamentoDaEntrega() {
  return `${BASE_URL_MOBILE_EXPEDICAO}/tracking/enderecamento/adicionar-endereco-entrega`
}

export function urlReportTagEnderecamentoEntrega(delivery_id) {
  return `${BASE_URL}/entregas/enderecamento-entregas/report-tag-entrega/${delivery_id}?t=${localStorage.getItem('t')}`
}

// Rastreabilidade Pallet
export function urlRastreabilidadePalletStatistics(tp_id, pallet_area_id) {
  return `${BASE_URL_MOBILE_EXPEDICAO}/pallet-area/statistics/${tp_id}?pallet_area_id=${pallet_area_id}`
}

export function urlRastreabilidadePalletTimeline(pallet_area_id) {
  return `${BASE_URL_MOBILE_EXPEDICAO}/pallet-area/events-timeline/${pallet_area_id}`
}

// Alterar status da entrega
export function urlAlterarStatusEntrega() {
  return `${BASE_URL}/alteracao-status-manual`
}

// Placas Prevista
export function urlAssocBadgeBySheet(typeOfSheet, roteirizacao_id) {
  return `${BASE_URL}/roteirizacao-previa/placa-prevista/from-sheet/${roteirizacao_id}/${typeOfSheet}`
}

export function urlAssocBadgeByData(roteirizacao_id) {
  return `${BASE_URL}/roteirizacao-previa/placa-prevista/${roteirizacao_id}`
}

// Informações Horario Saida
export function urlGetFleetsToDepartureTime(tp_id) {
  return `${BASE_URL}/fleets-to-deliver/departure-time/${tp_id}`
}

// Justificativa Cargas Paragas
export function urlGetDeliveriesToJustify(tp_id, pInicial, pFinal, company_id, identifier) {
  const query = [`pInicial=${pInicial}`, `pFinal=${pFinal}`]

  if (company_id) query.push(`company_id=${company_id}`)
  if (identifier) query.push(`identifier=${encodeURIComponent(identifier)}`)

  return `${BASE_URL}/justify-deliveries/${tp_id}?${query.join('&')}`
}

export function urlSaveJustifyToDeliveries(tp_id) {
  return `${BASE_URL}/justify-deliveries/${tp_id}`
}

// Gestão de Canhoto
export function urlRelacaoTransportadoraCanhoto(tpId, dataInicial, dataFinal, companyId) {
  return `${BASE_URL}/gestao-canhotos/${tpId}?dataInicial=${dataInicial}&dataFinal=${dataFinal}&companyId=${companyId}`
}

export function urlDownloadCanhotosGestao(tpId) {
  return `${BASE_URL}/gestao-canhotos/download-canhotos/${tpId}`
}

function montarQueryGestaoCanhotos(params) {
  return Object.entries(params)
    .filter(([, value]) => value !== null && value !== undefined && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')
}

export function urlRelacaoEntregasCanhoto(tpId, params) {
  return `${BASE_URL}/gestao-canhotos/entregas/${tpId}?${montarQueryGestaoCanhotos(params)}`
}

export function urlResumoEntregasCanhoto(tpId, params) {
  return `${BASE_URL}/gestao-canhotos/entregas-resumo/${tpId}?${montarQueryGestaoCanhotos(params)}`
}

export function urlIdsEntregasCanhoto(tpId, params) {
  return `${BASE_URL}/gestao-canhotos/entregas-ids/${tpId}?${montarQueryGestaoCanhotos(params)}`
}

export function urlGetDeliveriesStatus() {
  return `${BASE_URL}/delivery-status`
}

export function urlGetEntregasParaCte(tp_id, company_id, p_inicial, p_final) {
  const inicial = parseToMysqlFormatWithTime(p_inicial)
  const final = parseToMysqlFormatWithTime(p_final)
  return `${BASE_URL}/deliveries-for-cte/${tp_id}?company_id=${company_id}&p_inicial=${inicial}&p_final=${final}`
}

export function urlPostDeliveryCicleConsolidado() {
  return `${BASE_URL}/delivery-cycle-consolidado`
}

// XML Delivery
export function urlGetXmlDeliveries(tpId, cycleId, dataInicial, dataFinal) {
  return `${BASE_URL}/cycles/${cycleId}/xml-deliveries?tp_id=${tpId}&data_emissao_start=${dataInicial}&data_emissao_end=${dataFinal}`
}

export function urlPostXmlDeliveriesAssociation(cycleId) {
  return `${BASE_URL}/cycles/${cycleId}/xml-associations`
}

export function urlGetXmlAssociationJob(jobId) {
  return `${BASE_URL}/xml-association-jobs/${jobId}`
}

export function urlDownloadXmls(tp, cycleId, start, end) {
  start = DateTime.fromJSDate(start).toFormat('yyyy-MM-dd')
  end = DateTime.fromJSDate(end).toFormat('yyyy-MM-dd')

  return `${BASE_URL}/cycles/${cycleId}/xmls/download?tp_id=${tp}&start=${start}&end=${end}`
}

export function urlGetTagPallet(tp_id, dataInicial, dataFinal) {
  return `${BASE_URL}/tag-pallet/${tp_id}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`
}

// Roteirização Automática
const BASE_URL_ROTEIRIZACAO_AUTOMATICA = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/roteirizacao-automatica`

export function urlPostSimularRoteirizacaoAutomatica() {
  return `${BASE_URL_ROTEIRIZACAO_AUTOMATICA}/simular`
}

export function urlGetGeolocationClientsByFleet(fleet_id) {
  return `${BASE_URL}/geolocation-tp-drive/${fleet_id}`
}

export function urlGetBateriasByFleet(fleet_id) {
  return `${BASE_URL}/bateria-tp-drive/${fleet_id}`
}

export function urlGetChatByFleet(fleet_id) {
  return `${BASE_URL}/chat-fleet/${fleet_id}`
}

export function urlGetChatByDelivery(delivery_id) {
  return `${BASE_URL}/chat-delivery/${delivery_id}`
}

export function urlGetRouteChatByFleet(fleet_id) {
  return `${BASE_URL}/route-chat/${fleet_id}`
}

export function urlGetRouteChatUnread(fleet_ids) {
  return `${BASE_URL}/route-chat/unread?fleet_ids=${fleet_ids.join(',')}`
}

export function urlGetAgendamentosEntrega(delivery_id) {
  return `${BASE_URL}/agendamentos-entrega/${delivery_id}`
}

export function urlPostPutAgendamentoEntrega() {
  return `${BASE_URL}/agendamentos-entrega`
}

export function urlGetDeliveryItemsByCycle(ciclo_id) {
  return `${BASE_URL}/ciclo-entrega-acao/delivery-items-by-cycle/${ciclo_id}`
}

export function urlXmlImportLogsByTp(tp_id, pInicial, pFinal) {
  return `${BASE_URL}/xml-import-logs/${tp_id}?pInicial=${pInicial}&pFinal=${pFinal}`
}

export function urlXmlImportLogFileByTp(tp_id, log_id) {
  return `${BASE_URL}/xml-import-logs/${tp_id}/${log_id}/file`
}
